var map = {
	"./3d.mp4": 3550,
	"./3d.webm": 1291,
	"./about-circle.mp4": 6172,
	"./about-circle.webm": 5436,
	"./background.webp": 1873,
	"./decoration-mini.webp": 5601,
	"./decoration.webp": 4003,
	"./logo/1.webp": 1622,
	"./logo/2.webp": 2295,
	"./logo/3.webp": 1284,
	"./logo/4.webp": 5269,
	"./main-decoration.webp": 4653,
	"./map.webp": 6021,
	"./people.webp": 5834,
	"./tariff/1.webp": 3099,
	"./tariff/2.png": 1169,
	"./waves.png": 2684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;